import { ScheduleRequest } from '@weave/schema-gen-ts/dist/schemas/schedule/api/v2/api.pb';
import { DataSourcesQueries } from '@frontend/api-data-sources';
import { useDevToolsStore } from '@frontend/devtools';
import { ContentLoader } from '@frontend/design-system';
import { useManageAppointmentWriteback } from '../../../../../../hooks';
import { ScheduleRequestModalContext, ScheduleRequestModalContextType } from '../Context/ScheduleRequestModalContext';
import { ScheduleRequestModal } from '../ScheduleRequestModal';
import { ScheduleReadOnlyRequestModal } from '../ScheduleRequestModal/ScheduleReadOnlyRequestModal/ScheduleReadOnlyRequestModal';

type ScheduleRequestFormManagerProps = {
  scheduleRequestModalContextValue: ScheduleRequestModalContextType;
  selectedScheduleRequest: ScheduleRequest;
};
export const ScheduleRequestFormManager = ({
  scheduleRequestModalContextValue,
  selectedScheduleRequest,
}: ScheduleRequestFormManagerProps) => {
  const locationId = selectedScheduleRequest.locationId ?? '';

  const { isIntegratedOffice, isLoading: isLoadingIntegrationDetails } =
    DataSourcesQueries.useGetAccessibleIntegrations();

  const { appointmentWritebackSourceTenants, isLoadingDataSources, isLoadingSourceTenants } =
    useManageAppointmentWriteback({
      isEnabled: isIntegratedOffice,
      locationId: locationId,
    });

  const isLoading = isLoadingIntegrationDetails || isLoadingDataSources || isLoadingSourceTenants;

  const isIntegratedWithoutWritebacks = isIntegratedOffice && !appointmentWritebackSourceTenants.length;

  const {
    options: { isDebugModeOn },
  } = useDevToolsStore();

  return (
    <>
      {isLoading ? (
        <ContentLoader />
      ) : (
        <ScheduleRequestModalContext.Provider value={scheduleRequestModalContextValue}>
          {isIntegratedWithoutWritebacks && !isDebugModeOn ? (
            <ScheduleReadOnlyRequestModal />
          ) : (
            <ScheduleRequestModal showWritebackWarning={isIntegratedWithoutWritebacks && isDebugModeOn} />
          )}
        </ScheduleRequestModalContext.Provider>
      )}
    </>
  );
};
